import ExternalLink from '@/ui/Link/ExternalLink';

// utils
import { routes } from '@/utils/routes';

import ByZeroEx from './ByZeroEx';
import ByZeroExGray30 from './ByZeroExGray30';

type Variant = 'gray30' | 'gray40' | 'black06';

const ByZeroExPill = ({ className, variant }: { className?: string; variant: Variant }) => {
  let pill;
  switch (variant) {
    case 'gray30':
      pill = <ByZeroExGray30 />;
      break;
    case 'gray40':
      pill = <ByZeroEx backgroundColor="#F7F7F8" style={{ display: 'block' }} />;
      break;
    case 'black06':
      pill = <ByZeroEx backgroundColor="rgba(22, 37, 70, 0.06)" style={{ display: 'block' }} />;
      break;
  }
  return (
    <ExternalLink className={className} href={routes.ZEROEX_HOME}>
      {pill}
    </ExternalLink>
  );
};

export default ByZeroExPill;
